import AppointmentsParticipantContainer from "../../container/participant/appointments/appointmentsParticipantContainer";
import AppointmentsParticipantContext from "../../container/participant/appointments/context/appointmentsParticipantContext";

const AppointmentsParticipant = (): React.JSX.Element => (
  <AppointmentsParticipantContext>
    <AppointmentsParticipantContainer />
  </AppointmentsParticipantContext>
);

export default AppointmentsParticipant;
